import { render, staticRenderFns } from "./m-icon-btn.vue?vue&type=template&id=1f48c7f1&scoped=true&"
import script from "./m-icon-btn.vue?vue&type=script&lang=js&"
export * from "./m-icon-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f48c7f1",
  null
  
)

export default component.exports